//
//
//
//
import echarts from 'echarts';
import tdTheme from './theme.json';
import { on, off } from '@/libs/tools';
echarts.registerTheme('tdTheme', tdTheme);
export default {
  name: 'ChartPie',
  props: {
    text: String,
    subtext: String,
    xAxisData: Array,
    seriesData: Array,
    legendData: Array
  },
  data: function data() {
    return {
      dom: null
    };
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    init: function init() {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {},
        yAxis: {
          type: 'value'
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData
        },
        series: this.seriesData
      };
      this.dom = echarts.init(this.$refs.dom, 'tdTheme');
      this.dom.setOption(option);
      on(window, 'resize', this.resize);
    },
    setOption: function setOption() {
      var option = {
        title: {
          text: this.text,
          subtext: this.subtext
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {},
        yAxis: {
          type: 'value'
        },
        xAxis: {
          type: 'category',
          data: this.xAxisData
        },
        series: this.seriesData
      };
      this.dom.setOption(option);
    }
  },
  computed: {
    getechartResize: function getechartResize() {
      return this.$store.state.echartResize;
    }
  },
  watch: {
    seriesData: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          if (newVal) {
            this.setOption(newVal);
          } else {
            this.setOption(oldVal);
          }
        } else {
          this.init();
        }
      },
      deep: true
    },
    getechartResize: function getechartResize(newVal, oldVal) {
      var _this = this;

      if (this.dom) {
        setTimeout(function () {
          _this.resize();
        }, 500);
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    off(window, 'resize', this.resize);
  }
};